var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specialBgc",style:({height: (_vm.height + "px")})},[(!_vm.logoError && _vm.EnterpriseId)?[_c('img',{staticClass:"bgcImg",attrs:{"src":_vm.logoUrl,"alt":""},on:{"error":function (){ _vm.logoError = true }}})]:[_c('img',{staticClass:"bgcImg",attrs:{"src":require("@/assets/images/banner-index.jpg"),"alt":""}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0475c47e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoCenter/banner.vue
// module id = Mf2r
// module chunks = 14